import api from "../../api.service";
import store from "../"
const state = {
    categoryReportList: [],
    doughnutList: [],
    linesList: [],
    series: [],
    series2: [],
    chartOptions: {
        chart: {
            height: 350,
            type: "line",
            zoom: {
                enabled: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "straight",
        },
        title: {
            align: "left",
        },
        legend: {
            tooltipHoverFormatter: function (val, opts) {
                return val + " - " + [opts.dataPointIndex] + "";
            },
        },
        markers: {
            size: 0,
            hover: {
                sizeOffset: 6,
            },
        },
        xaxis: {
            categories: [
                "كانون الثاني",
                "شباط",
                "آذار",
                "نيسان",
                "أيار",
                "حزيران",
                "تموز",
                "آب",
                "أيلول",
                "تشرين الأول",
                "تشرين الثاني",
                "كانون الأول",
            ],
        },
        tooltip: {
            y: [
                {
                    title: {
                        formatter: function (val) {
                            return val;
                        },
                    },
                },
            ],
        },
        grid: {
            borderColor: "#f1f1f1",
        },
    },
    chartOptions2: {
        labels: [],
        chart: {
            width: 380,
            type: "donut",
        },
        dataLabels: {
            enabled: false,
        },
        colors: [],
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        show: false,
                    },
                },
            },
        ],
        legend: {
            position: "left",
            offsetY: 50,
            height: 230,
        },
    },
    filterForm: {
        cityIds: [],
        areaIds: [],
        categoryIds: [],
        wantedYear: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
    },
};
const getters = {
    doughnutList(state) {
        return state.doughnutList;
    },
    linesList(state) {
        return state.linesList;
    },
    series(state) {
        return state.series;
    },
    series2(state) {
        return state.series2;
    },
    chartOptions(state) {
        return state.chartOptions;
    },
    chartOptions2(state) {
        return state.chartOptions2;
    },
    filterForm(state) {
        return state.filterForm;
    },
    categoryReportList(state) {
        return state.categoryReportList;
    }
};
const mutations = {
    GET_D_ITEMS(state, payload) {
        state.doughnutList = payload;
        state.series2 = [];
        state.chartOptions2.labels = [];
        state.chartOptions2.colors = []
        state.doughnutList.forEach((element) => {
            state.chartOptions2.colors.push(element.color)
            state.series2.push(element.shopsCount);
        });
        state.doughnutList.forEach((element) => {
            state.chartOptions2.labels.push(element.categoryName);
        });
    },
    GET_L_ITEMS(state, payload) {
        state.series = [];
        payload.forEach((element) => {
            state.series.push({
                name: element.categoryName,
                data: element.shopsCount,
                color: element.color
            });
        })
        store.dispatch('setLoading', false);
    },
    SAVE_CATEGORY_ITEMS(state, payload) {
        state.categoryReportList = payload;
    }


};
const actions = {
    async fetchDReport(context, payload) {
        const { data } = await api
            .post(`/api/Report/GetShopCategories`, payload)
            .then(data => data);
        context.commit("GET_D_ITEMS", data);
    },

    async fetchLReport(context, payload) {
        store.dispatch('setLoading', true);
        const { data } = await api
            .post(`/api/Report/GetShopCategoryMonthly`, payload)
            .then(data => data);
        context.commit("GET_L_ITEMS", data);
    },

    async fetchCategory(context) {
        store.dispatch('setLoading', true);
        const { data } = await api
            .get(`/api/category/CategoriesList`)
            .then(data => data);
        context.commit("SAVE_CATEGORY_ITEMS", data);
    },

};

const report = { state, getters, mutations, actions };

export default report;